import { planoIncluiModulo } from '@shared/services/plan-capabilities.service';
import { ItemDeMenu } from './menu.model';

export function menuDoPlano(itens: ItemDeMenu[], modulos: readonly string[] | null | undefined): ItemDeMenu[] {
  return itens.flatMap(item => {
    if (item.module && !planoIncluiModulo(modulos, item.module)) return [];
    if (!item.submenu) return [item];
    const submenu = menuDoPlano(item.submenu, modulos);
    return submenu.length ? [{ ...item, submenu }] : [];
  });
}
